/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ChecklistId202,
  PutApiV1ChecklistId400,
  PutApiV1ChecklistId401,
  PutApiV1ChecklistId404,
  PutApiV1ChecklistId409,
  PutApiV1ChecklistId500,
  PutApiV1ChecklistIdMutationRequest,
  PutApiV1ChecklistIdMutationResponse,
  PutApiV1ChecklistIdPathParams,
} from "../../types/checkListRegistroController/PutApiV1ChecklistId.ts";
import { checkListViewModelSchema } from "../checkListViewModelSchema.ts";
import { updateCheckListRequestViewModelSchema } from "../updateCheckListRequestViewModelSchema.ts";

export const putApiV1ChecklistIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ChecklistIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1ChecklistId202Schema = z.lazy(
  () => checkListViewModelSchema,
) as unknown as ToZod<PutApiV1ChecklistId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ChecklistId400Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ChecklistId401Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ChecklistId404Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1ChecklistId409Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ChecklistId500Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistId500>;

export const putApiV1ChecklistIdMutationRequestSchema = z.lazy(
  () => updateCheckListRequestViewModelSchema,
) as unknown as ToZod<PutApiV1ChecklistIdMutationRequest>;

export const putApiV1ChecklistIdMutationResponseSchema = z.lazy(
  () => putApiV1ChecklistId202Schema,
) as unknown as ToZod<PutApiV1ChecklistIdMutationResponse>;
